



























































import Autocomplete from 'vuejs-auto-complete';
import Vue from 'vue';
import { Component, Prop } from "vue-property-decorator";

/*
    * Component's properties and events
*/
@Component({
    components: {
        Autocomplete
    }
})
export default class TitleSearchComponent extends Vue {   
    /*
        *  A component�s settings option must be a function, so that each instance can maintain an independent copy of the returned data object.
    */
    settings() {
        // @ts-ignore
        return this.$store.state[this.$options.parent.fileName];
    }

    /*
           * Gets all data based on the typehead.
       */
    _tsGetData(value) {
        // let context = this.$store.state[this.$options.parent.fileName],
        //     fieldName = context.orginTitle.substr(2).slice(0, -2),
        //     id = this.$store.state.dashboard.componentId;

        // return this.$store.state[this.$options.parent.fileName].actions.searchAction + id + '/' + value + '/' + fieldName;
    }

    /*
        * Gets all filter data based selection.
    */
    _tsGetFilterData(record) {
        // let context = this.$store.state[this.$options.parent.fileName],
        //     name = record.selectedObject.DisplayText;

        // //#. Remove the component in the DOM
        // this.$store.state.dashboard.renderComponent = false;
        // //#. Remove the title search buttons in the DOM
        // context.renderTitleSearchComponent = false;
        // this.$store.state.dashboard.componentId = record.selectedObject.Value;

        // //#.URL state reset
        // history.pushState({
        //     id: ''
        // }, '', window.location.href.substr(0,window.location.href.indexOf('#') + 1) + record.selectedObject.Value);

        // //#. Add the component back in based on the componentId
        // this.$nextTick(() => {
        //     //#. Add the search button back in
        //     context.renderTitleSearchComponent = true;
        //     //#. Add the component back in
        //     this.$store.dispatch('renderComponent');
        //     context.title = name;
        // });
    }

    /*
        * Search button event raising methods
    */
    _tsSearchBtnClick(formData) {
        // let context = this.$store.state[this.$options.parent.fileName];

        // //#.Enable title search are triggered with the store.dispatch method.
        // this.$store.dispatch('search', context);
    }

    /*
        * Close button event raising methods
    */
    _tsCloseBtnClick(formData) {
        // let context = this.$store.state[this.$options.parent.fileName];

        // //#.Remove title search are triggered with the store.dispatch method.
        // this.$store.dispatch('removeSearch', context);
    }
}
